import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClockComponent } from './clock.component';
import { SharedProviderModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    SharedProviderModule
  ],
  declarations: [ClockComponent],
  exports: [ClockComponent]
})
export class ClockModule { }
